import {useGetAndSet} from "./useGetAndSet";
import {createSetRateCardsDataAction} from "../actions/dataActions";

export const useRateCardsData = (params, dataFresh) => {
    return useGetAndSet("ratecard", params, createSetRateCardsDataAction, dataFresh);
}